export function registerComponents(Vue: any, components: object, includeComponents?: string[]) {
    for (let key in components) {
        if (!includeComponents || includeComponents.includes(key)) {
            registerComponent(Vue, key, (<any>components)[key]);
        }
    }
}

export function registerComponent(Vue: any, key: string, component: any) {
    Vue.component(component.name || kebabize(key), component);
}

function kebabize(key: string) {
    let s = "", n = false;

    for (let i = 0 ; i < key.length ; i++) {
        if (key[i].toLowerCase() != key[i] || (/\d/.test(key[i]) && !n)) {
            s += "-";
            s+= key[i].toLowerCase();
        }
        else {
            s += key[i];
        }

        n = /\d/.test(key[i]);
    }

    return s.replace(/(^-+|-+$)/g, '');
}
